// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2tiLs","resendInfoText":"OnGoingPaymentBox_resendInfoText__2l077"};